export default __webpack_public_path__ + "static/media/woman-profile.d57874bf.svg";